import React, { useState } from 'react'
import { Wrapper } from './style'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
const PlanAmountToSave = () => {
  const [planData, setPlanData] = useState({
    amount_to_save: '',
  })
  const checkurl = () => {
    if (window.location.href.indexOf('general') > -1) {
      return 'general'
    } else if (window.location.href.indexOf('target') > -1) {
      return 'target'
    } else if (window.location.href.indexOf('contest') > -1) {
      return 'contest'
    }
  }
  const type = checkurl()

  let location = useLocation()
  const dispatch = useDispatch()
  const { amount_to_save } = planData

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes.UPDATE_PAYMENT_FORM, newData))
  }
  const quickSave = (e: any) => {
    if (!amount_to_save) {
      e.preventDefault()
    } else {
    }
    // setShowModal(true)
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <h2 className="title">Amount to save</h2>
          <p className="desc">How much do you want to save?</p>
          <QuicksaveInput
            type="number"
            name="amount_to_save"
            value={amount_to_save}
            placeholder="100,000"
            onChange={handleChange}
          />
        </div>
        <div>
          <Link
            to={`/${type}-payment-detail`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="button" onClick={quickSave}>
              Continue
            </ModalButton>
          </Link>
        </div>
      </form>
    </Wrapper>
  )
}

export { PlanAmountToSave }
